(() => {
  if (window.SSAjaxCartReady) return;
  window.SSAjaxCartReady = true;

  const route = {
    add: window.routes?.cart_add_url || '/cart/add.js',
    change: window.routes?.cart_change_url || '/cart/change.js'
  };

  function surface() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sections(cart) {
    return cart?.getSectionsToRender?.().map((item) => item.section || item.id).filter(Boolean) || ['cart-icon-bubble'];
  }

  function error(form, message = '') {
    let element = form.querySelector('.ss-ajax-error');
    if (!element) {
      element = document.createElement('p');
      element.className = 'ss-ajax-error';
      element.setAttribute('role', 'alert');
      element.style.cssText = 'display:none;color:#b42318;margin:10px 0 0;font-size:14px';
      form.querySelector('.ss-product__buttons')?.after(element);
    }
    element.textContent = message;
    element.style.display = message ? 'block' : 'none';
  }

  function busy(form, state) {
    const add = form.querySelector('.ss-button--cart');
    const control = form.querySelector('.ss-ajax-quantity');
    add?.classList.toggle('is-loading', state);
    control?.classList.toggle('is-loading', state);
    if (add) add.disabled = state;
    control?.querySelectorAll('button').forEach((button) => button.disabled = state);
  }

  function updateIcon(state) {
    const html = state?.sections?.['cart-icon-bubble'];
    const current = document.getElementById('cart-icon-bubble');
    if (!html || !current) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
    if (!fresh) return;
    current.innerHTML = fresh.innerHTML;
    current.classList.remove('ss-cart-bounce');
    requestAnimationFrame(() => current.classList.add('ss-cart-bounce'));
  }

  function publish(state, variantId) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'ss-ajax-cart',
        productVariantId: String(variantId),
        cartData: state
      });
    }
  }

  function showControl(form, quantity, key, variantId) {
    const add = form.querySelector('.ss-button--cart');
    const control = form.querySelector('.ss-ajax-quantity');
    const value = control.querySelector('span');
    control.dataset.key = key;
    control.dataset.variantId = variantId;
    value.dataset.quantity = quantity;
    value.textContent = quantity;
    add.classList.add('ss-ajax-original-hidden');
    add.hidden = true;
    control.hidden = false;
    requestAnimationFrame(() => control.classList.add('is-visible'));
  }

  function showAdd(form) {
    const add = form.querySelector('.ss-button--cart');
    const control = form.querySelector('.ss-ajax-quantity');
    control.classList.remove('is-visible');
    control.hidden = true;
    control.dataset.key = '';
    add.classList.remove('ss-ajax-original-hidden');
    add.hidden = false;
    add.disabled = false;
  }

  async function add(form) {
    const button = form.querySelector('.ss-button--cart');
    const variant = form.querySelector('[name="id"]');
    const cart = surface();
    error(form);
    busy(form, true);
    const data = new FormData(form);
    data.set('quantity', '1');
    data.set('sections', sections(cart).join(','));
    data.set('sections_url', location.pathname);
    try {
      const response = await fetch(route.add, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this product.');
      showControl(form, state.quantity || 1, state.key, variant.value);
      if (cart?.renderContents) {
        cart.setActiveElement?.(button);
        cart.renderContents(state);
      } else updateIcon(state);
      publish(state, variant.value);
    } catch (reason) {
      error(form, reason.message || 'Something went wrong. Please try again.');
    } finally {
      busy(form, false);
    }
  }

  async function change(form, quantity) {
    const control = form.querySelector('.ss-ajax-quantity');
    const value = control.querySelector('span');
    const cart = surface();
    error(form);
    busy(form, true);
    try {
      const response = await fetch(route.change, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: control.dataset.key,
          quantity: Math.max(0, quantity),
          sections: sections(cart),
          sections_url: location.pathname
        })
      });
      const state = await response.json();
      if (!response.ok || state.errors || state.status) throw new Error(state.description || state.message || state.errors || 'Unable to update quantity.');
      updateIcon(state);
      publish(state, control.dataset.variantId);
      if (quantity <= 0) showAdd(form);
      else {
        value.textContent = quantity;
        value.dataset.quantity = quantity;
        value.classList.remove('is-changing');
        requestAnimationFrame(() => value.classList.add('is-changing'));
      }
    } catch (reason) {
      error(form, reason.message || 'Something went wrong. Please try again.');
    } finally {
      busy(form, false);
    }
  }

  function setup(form) {
    if (form.dataset.ssAjaxReady) return;
    const addButton = form.querySelector('.ss-button--cart');
    if (!addButton) return;
    form.dataset.ssAjaxReady = 'true';
    const oldQuantity = form.querySelector('.ss-quantity')?.closest('.ss-form-group');
    if (oldQuantity) oldQuantity.hidden = true;
    const control = document.createElement('div');
    control.className = 'ss-ajax-quantity';
    control.hidden = true;
    control.innerHTML = '<button type="button" data-action="minus" aria-label="Decrease quantity">−</button><span data-quantity="1" aria-live="polite">1</span><button type="button" data-action="plus" aria-label="Increase quantity">+</button>';
    addButton.after(control);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      add(form);
    }, true);
    control.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-action]');
      if (!button) return;
      const value = control.querySelector('span');
      const current = parseInt(value.dataset.quantity, 10) || 1;
      change(form, button.dataset.action === 'plus' ? current + 1 : current - 1);
    });
    form.querySelector('[name="id"]')?.addEventListener('change', () => showAdd(form));
  }

  function init(root = document) {
    root.querySelectorAll('.ss-product-form').forEach(setup);
  }

  const style = document.createElement('style');
  style.textContent = '.ss-ajax-original-hidden{display:none!important;visibility:hidden!important}.ss-ajax-quantity[hidden]{display:none!important}.ss-ajax-quantity{width:100%;min-height:52px;grid-template-columns:1fr 72px 1fr;align-items:center;border:1px solid currentColor;border-radius:8px;overflow:hidden;opacity:0;transform:scale(.97);transition:.18s ease}.ss-ajax-quantity.is-visible{display:grid;opacity:1;transform:scale(1)}.ss-ajax-quantity.is-loading,.ss-button--cart.is-loading{opacity:.6;pointer-events:none}.ss-ajax-quantity button{height:100%;min-height:52px;border:0;background:transparent;color:inherit;font:inherit;font-size:24px;cursor:pointer}.ss-ajax-quantity button:hover{background:rgba(0,0,0,.07)}.ss-ajax-quantity span{text-align:center;font-size:17px;font-weight:700}.ss-ajax-quantity span.is-changing{animation:ss-pop .22s ease}#cart-icon-bubble.ss-cart-bounce{animation:ss-bounce .35s ease}@keyframes ss-pop{50%{transform:scale(1.18)}}@keyframes ss-bounce{45%{transform:scale(1.18)}70%{transform:scale(.94)}}';
  document.head.appendChild(style);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* Restore every Add to Cart control from the real cart after navigation. */
(() => {
  if (window.SSAjaxCartHydrationReady) return;
  window.SSAjaxCartHydrationReady = true;

  let cartRequest;

  function readCart() {
    if (!cartRequest) {
      const cartURL = (window.routes?.cart_url || '/cart').replace(/\/$/, '') + '.js';
      cartRequest = fetch(cartURL, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to read cart');
          return response.json();
        })
        .finally(() => {
          window.setTimeout(() => { cartRequest = null; }, 150);
        });
    }
    return cartRequest;
  }

  function variantId(form) {
    return String(form.querySelector('[name="id"]')?.value || '');
  }

  function restoreForm(form, cart) {
    const id = variantId(form);
    if (!id) return;

    const matchingItems = (cart.items || []).filter(
      (item) => String(item.variant_id) === id
    );
    const item = matchingItems[0];
    const addButton = form.querySelector(
      '.ss-button--cart, button[type="submit"][name="add"], button[name="add"]'
    );
    const control = form.querySelector('.ss-ajax-quantity');
    if (!addButton || !control) return;

    if (!item) {
      control.classList.remove('is-visible');
      control.hidden = true;
      control.dataset.key = '';
      addButton.classList.remove('ss-ajax-original-hidden');
      addButton.hidden = false;
      if (!addButton.classList.contains('is-loading')) addButton.disabled = false;
      return;
    }

    const value = control.querySelector('span');
    control.dataset.key = item.key;
    control.dataset.variantId = id;
    if (value) {
      value.textContent = String(item.quantity);
      value.dataset.quantity = String(item.quantity);
    }
    addButton.classList.add('ss-ajax-original-hidden');
    addButton.hidden = true;
    control.hidden = false;
    requestAnimationFrame(() => control.classList.add('is-visible'));
  }

  async function hydrate(root = document) {
    try {
      const cart = await readCart();
      const forms = root.matches?.('form')
        ? [root]
        : Array.from(root.querySelectorAll?.('form') || []);
      forms.forEach((form) => restoreForm(form, cart));
    } catch (error) {
      console.error('[AJAX cart restore]', error);
    }
  }

  function start() {
    window.setTimeout(() => hydrate(document), 0);

    document.addEventListener('change', (event) => {
      if (!event.target.matches?.('[name="id"]')) return;
      const form = event.target.closest('form');
      if (form) window.setTimeout(() => hydrate(form), 0);
    });

    document.addEventListener('shopify:section:load', (event) => {
      window.setTimeout(() => hydrate(event.target), 0);
    });

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) window.setTimeout(() => hydrate(node), 0);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Global Add to Cart support for product cards, search and custom sections. */
(() => {
  if (window.SSGlobalAjaxCartReady) return;
  window.SSGlobalAjaxCartReady = true;

  const addURL = window.routes?.cart_add_url || '/cart/add.js';
  const changeURL = window.routes?.cart_change_url || '/cart/change.js';

  const getSurface = () =>
    document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const getSections = (cart) =>
    cart?.getSectionsToRender?.().map((item) => item.section || item.id).filter(Boolean) ||
    ['cart-icon-bubble'];

  function buttonFor(form) {
    return form.querySelector('button[type="submit"][name="add"], button[name="add"]');
  }

  function prepare(form) {
    if (form.classList.contains('ss-product-form') || form.dataset.ssGlobalAjaxReady) return;
    const addButton = buttonFor(form);
    if (!addButton) return;
    form.dataset.ssGlobalAjaxReady = 'true';
    const control = document.createElement('div');
    control.className = 'ss-ajax-quantity ss-global-ajax-quantity';
    control.hidden = true;
    control.innerHTML = '<button type="button" data-action="minus" aria-label="Decrease quantity">−</button><span data-quantity="1" aria-live="polite">1</span><button type="button" data-action="plus" aria-label="Increase quantity">+</button>';
    addButton.insertAdjacentElement('afterend', control);
    control.addEventListener('click', (event) => {
      const action = event.target.closest('button[data-action]')?.dataset.action;
      if (!action || control.classList.contains('is-loading')) return;
      const value = control.querySelector('span');
      const current = parseInt(value.dataset.quantity, 10) || 1;
      update(form, action === 'plus' ? current + 1 : current - 1);
    });
    form.querySelector('[name="id"]')?.addEventListener('change', () => reset(form));
  }

  function setBusy(form, busy) {
    const addButton = buttonFor(form);
    const control = form.querySelector('.ss-global-ajax-quantity');
    addButton?.classList.toggle('is-loading', busy);
    control?.classList.toggle('is-loading', busy);
    if (addButton) addButton.disabled = busy;
    control?.querySelectorAll('button').forEach((button) => button.disabled = busy);
  }

  function show(form, quantity, key, variantId) {
    const addButton = buttonFor(form);
    const control = form.querySelector('.ss-global-ajax-quantity');
    if (!addButton || !control) return;
    const value = control.querySelector('span');
    control.dataset.key = key;
    control.dataset.variantId = variantId;
    value.textContent = quantity;
    value.dataset.quantity = quantity;
    addButton.classList.add('ss-ajax-original-hidden');
    addButton.hidden = true;
    control.hidden = false;
    requestAnimationFrame(() => control.classList.add('is-visible'));
  }

  function reset(form) {
    const addButton = buttonFor(form);
    const control = form.querySelector('.ss-global-ajax-quantity');
    if (!addButton || !control) return;
    control.classList.remove('is-visible');
    control.hidden = true;
    control.dataset.key = '';
    addButton.classList.remove('ss-ajax-original-hidden');
    addButton.hidden = false;
    addButton.disabled = false;
  }

  function updateIcon(state) {
    const html = state?.sections?.['cart-icon-bubble'];
    const current = document.getElementById('cart-icon-bubble');
    if (!html || !current) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
    if (!fresh) return;
    current.innerHTML = fresh.innerHTML;
    current.classList.remove('ss-cart-bounce');
    requestAnimationFrame(() => current.classList.add('ss-cart-bounce'));
  }

  function announce(state, variantId) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'ss-global-ajax-cart',
        productVariantId: String(variantId),
        cartData: state
      });
    }
  }

  async function submit(form) {
    prepare(form);
    const addButton = buttonFor(form);
    const variant = form.querySelector('[name="id"]');
    if (!addButton || !variant || variant.disabled) return;
    const cart = getSurface();
    const data = new FormData(form);
    if (!data.get('quantity')) data.set('quantity', '1');
    data.set('sections', getSections(cart).join(','));
    data.set('sections_url', location.pathname);
    setBusy(form, true);
    try {
      const response = await fetch(addURL, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message);
      show(form, state.quantity || Number(data.get('quantity')) || 1, state.key, variant.value);
      if (cart?.renderContents) {
        cart.setActiveElement?.(addButton);
        cart.renderContents(state);
      } else updateIcon(state);
      announce(state, variant.value);
    } catch (error) {
      console.error('[Global AJAX cart]', error);
      addButton.disabled = false;
    } finally {
      setBusy(form, false);
    }
  }

  async function update(form, quantity) {
    const control = form.querySelector('.ss-global-ajax-quantity');
    const value = control?.querySelector('span');
    if (!control?.dataset.key || !value) return;
    const cart = getSurface();
    setBusy(form, true);
    try {
      const response = await fetch(changeURL, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: control.dataset.key,
          quantity: Math.max(0, quantity),
          sections: getSections(cart),
          sections_url: location.pathname
        })
      });
      const state = await response.json();
      if (!response.ok || state.errors || state.status) throw new Error(state.description || state.message || state.errors);
      updateIcon(state);
      announce(state, control.dataset.variantId);
      if (quantity <= 0) reset(form);
      else {
        value.textContent = quantity;
        value.dataset.quantity = quantity;
        value.classList.remove('is-changing');
        requestAnimationFrame(() => value.classList.add('is-changing'));
      }
    } catch (error) {
      console.error('[Global AJAX cart quantity]', error);
    } finally {
      setBusy(form, false);
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.classList.contains('ss-product-form')) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add') || !buttonFor(form)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    submit(form);
  }, true);

  function scan(root = document) {
    root.querySelectorAll('form').forEach((form) => {
      const action = form.getAttribute('action') || '';
      if (action.includes('/cart/add')) prepare(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === 1) scan(node.matches?.('form') ? node.parentElement : node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
